import React, { Component, Fragment } from "react";
import * as PropTypes from "prop-types";

import { Modal, message, Tooltip } from "antd";

import moment from "moment";

import { timeCardService } from "./../../../redux/services";

import ModalAjustes from "../ModalAjustes";
import ModalActions from "../ModalActions";
import ModalDetails from "../ModalDetails";
import ModalRecalculating from "../ModalRecalculating";

class TableRow extends Component {
	static propTypes = {
		columns: PropTypes.arrayOf(
			PropTypes.shape({
				title    : PropTypes.string,
				className: PropTypes.string,
				width    : PropTypes.any,
				visible  : PropTypes.bool,
				render   : PropTypes.func.isRequired,
			}),
		),
		item: PropTypes.object,
		index: PropTypes.number,
	}

	constructor(props) {
		super(props);

		this.state = {
			ajustesModalVisible: false,
			actionsModalVisible: false,
			detailsModalVisible: false,
			recalculating: false,
			recalculatingFinished: false,
		};
	}

	actionsOpen = () => {
		this.setState({ actionsModalVisible: true });

		// On open screen
		this.actionsScreen.onOpen();
	};

	actionsOnClose = () => {
		this.setState({ actionsModalVisible: false });
	}

	actionsOnComplete = (item) => {
		this.setState({ actionsModalVisible: false });
		this.props.updateRow(item);
	}

	detailsOpen = () => {
		this.setState({ detailsModalVisible: true });

		// On open screen
		this.detailsScreen.onOpen();
	};

	detailsOnClose = () => {
		this.setState({ detailsModalVisible: false });
	}

	detailsOnComplete = (reloadRow) => {
		this.setState({ detailsModalVisible: false });
		if (reloadRow) this.props.reloadRow(reloadRow);
	}

	ajustesOpen = () => {
		this.setState({ ajustesModalVisible: true });

		// On open screen
		this.ajustesScreen.onOpen();
	};

	ajustesOnClose = () => {
		this.setState({ ajustesModalVisible: false });
	}

	ajustesOnComplete = () => {
		this.setState({ ajustesModalVisible: false });
	}

	restartOpen = (manter_jornada_original = false) => {
		if (this.props.item?.status !== 'execao') {
			return this.confirmRestart(manter_jornada_original);
		}
		Modal.confirm({
			title: `Deseja manter as exceções caso houver?`,
			content: "Esta ação não poderá ser desfeita.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				this.confirmRestart(manter_jornada_original, true);
			},
			onOk: () => {
				this.confirmRestart(manter_jornada_original, false);
			},
		});		
	};

	confirmRestart = (manter_jornada_original, deletar_execao) => {
		Modal.confirm({
			title: `Deseja voltar os dados originais para esse dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]?`,
			content: "Esta ação não poderá ser desfeita.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				document.querySelector(".ant-modal-wrap").focus();
			},
			onOk: () => {
				this.restartOnComplete(manter_jornada_original, deletar_execao);
			},
		});
	}

	restartOnComplete = (
		manter_jornada_original = false, 
		deletar_execao = null,
	) => {
		this.setState({ recalculating: true, recalculatingFinished: false });

		return timeCardService
			.restart({
				cartao_ponto_id: this.props.item.id,
				manter_jornada_original,
				deletar_execao,
			})
			.then((response) => {
				this.setState({ recalculatingFinished: true });
				// this.props.fetchGetAll(true);
				const base = moment(this.props.dataDia);
				const initial = base.clone().subtract(1, 'day').format('YYYY-MM-DD');
				const final = base.clone().add(1, 'day').format('YYYY-MM-DD');

				//TODO buscar apenas de um periodo estava gerando desencontro nos totais.
				// this.props.fetchGetItems(true, initial, final, false, 1);
				setTimeout(() => {
					this.setState({ recalculating: false });
					this.props.fetchGetAll(true);
					this.actionsOnClose();

					// Success message
					message.success('Os dados originais voltaram com sucesso.');
				}, 500);
			})
			.catch((data) => {
				this.setState({ recalculating: false });

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}

	reindexarBatidasOpen = () => {
		Modal.confirm({
			title: `Deseja reindexar as batidas para o dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]?`,
			content: "As batidas serão reordenadas cronologicamente.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				document.querySelector(".ant-modal-wrap").focus();
			},
			onOk: () => {
				return this.reindexarBatidasOnComplete();
			},
		});
	};

	reindexarBatidasOnComplete = () => {
		return timeCardService
			.reindexarBatidas({
				cartao_ponto_id: this.props.item.id,
			})
			.then((response) => {
				this.props.fetchGetAll(true);
				this.actionsOnClose();
				message.success('Batidas reindexadas com sucesso.');
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	}

	limparCartaoPontoOpen = () => {
		Modal.confirm({
			title: `Deseja limpar o cartão ponto do dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]?`,
			content: "Todos os ajustes serão removidos e as batidas ficarão em branco. Utilize 'Retornar dados originais' ou 'Reindexar batidas' para repopular.",
			okText: "Sim",
			cancelText: "Não",
			centered: true,
			onCancel: () => {
				document.querySelector(".ant-modal-wrap").focus();
			},
			onOk: () => {
				return timeCardService
					.limparCartaoPonto({ cartao_ponto_id: this.props.item.id })
					.then(() => {
						this.props.fetchGetAll(true);
						this.actionsOnClose();
						message.success('Cartão ponto limpo com sucesso.');
					})
					.catch((data) => {
						Modal.error({
							title: "Ocorreu um erro!",
							content: String(data),
						});
					});
			},
		});
	};

	recalcularDiaOpen = () => {
		Modal.confirm({
			title: `Recalcular o dia [${moment(this.props.dataDia).format("DD/MM/YYYY")}]`,
			content: "Deseja reindexar as batidas junto com o recálculo?",
			okText: "Com reindex",
			cancelText: "Sem reindex",
			centered: true,
			onOk: () => {
				return this.recalcularDiaExecutar(true);
			},
			onCancel: () => {
				return this.recalcularDiaExecutar(false);
			},
		});
	};

	recalcularDiaExecutar = (reindexar_batidas) => {
		return timeCardService
			.recalcularDia({
				cartao_ponto_id: this.props.item.id,
				reindexar_batidas,
			})
			.then(() => {
				this.props.fetchGetAll(true);
				this.actionsOnClose();
				message.success(`Recalculado com sucesso${reindexar_batidas ? ' (com reindex)' : ''}.`);
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	getBackgroundColorForStatus(status) {
		switch (status) {
			case 'folga':
				return '#94EDF9';
			case 'feriado':
				return '#8DB1FA';
			case 'dia_especial':
				return '#FA97CB';
			case 'afastamento':
				return '#FED58B';
			case 'execao':
				return '#59f2e4';
			case 'justificativa_parcial':
				return 'rgb(81,0,202, 0.35)';
			case 'dia_todo':
				return 'rgb(250, 200, 255)';
			default:
				return 'transparent';
		}
	}

	render() {
		const { columns, item, index } = this.props;
		const necessitaReindex = item?.necessita_reindex;

		return (
			<Fragment>
				<Tooltip title={necessitaReindex ? "Batidas fora de ordem cronológica. Utilize 'Reindexar batidas' nas ações." : ''} placement="left">
					<div
						className={`time-card-grid-row ${necessitaReindex ? "needs-reindex" : ""}`}
						style={{ "--time-card-status-color": this.getBackgroundColorForStatus(item.status) }}
					>
						{columns.map((column, col_index) => (
							<div
								key={col_index}
								className={`time-card-grid-cell ${column.className || ""}`}
								style={{
									width   : column.width,
									minWidth: column.width,
									maxWidth: column.width,
								}}
							>
								{column.render(item, index, { openActions: this.actionsOpen })}
							</div>
						))}
					</div>
				</Tooltip>
				<ModalDetails
					ref={el => this.detailsScreen = el}
					visible={this.state.detailsModalVisible}
					onComplete={this.detailsOnComplete}
					onClose={this.detailsOnClose}
					empresa={item?.contrato?.empresa?.nome}
					departamento={item?.departamento?.nome}
					funcionario={item?.funcionario?.nome}
					dataDia={this.props.dataDia}
					cartaoPontoId={item?.id}
					contrato={item?.contrato}
					funcionario_id={item?.funcionario?.id}
				/>
				<ModalActions
					ref={el => this.actionsScreen = el}
					visible={this.state.actionsModalVisible}
					onComplete={this.actionsOnComplete}
					onClose={this.actionsOnClose}
					restartOpen={this.restartOpen}
					reindexarBatidasOpen={this.reindexarBatidasOpen}
					limparCartaoPontoOpen={this.limparCartaoPontoOpen}
					recalcularDiaOpen={this.recalcularDiaOpen}
					detailsOpen={this.detailsOpen}
					newJoinColumn={() => { this.props.newJoinColumn(), this.actionsOnClose() }}
					removeBatida={() => { this.props.removeBatida(), this.actionsOnClose() }}
					journeyOpen={this.props.journeyOpen}
					dataDia={this.props.dataDia}
					empresa={item?.contrato?.empresa}
					departamento={item?.departamento}
					funcionario={item?.funcionario}
					cartaoPontoId={item?.id}
					tipoCalculo={item?.tipo_calculo}
					item={item}
					dataInicial={this.props.dataInicial}
					dataFinal={this.props.dataFinal}
					reloadRow={this.props.reloadRow}
				/>
				<ModalAjustes
					ref={el => this.ajustesScreen = el}
					visible={this.state.ajustesModalVisible}
					onComplete={this.ajustesOnComplete}
					onClose={this.ajustesOnClose}
					dataDia={this.props.dataDia}
					funcionarioId={item?.funcionario?.id}
				/>
				<ModalRecalculating
					visible={this.state.recalculating}
					finished={this.state.recalculatingFinished}
					description={`Estamos retornando os dados originais para o dia ${moment(this.props.dataDia).format("DD/MM/YYYY")}.`}
				/>
			</Fragment>
		)
	}
}

export default TableRow;
